import { useEffect } from 'react';
import { useScript } from 'usehooks-ts';

export const googleMapKey = process.env['STORYBOOK_GMAPS_API'] || process.env['NEXT_PUBLIC_GMAPS_API'];

export const useGmapsScript = ({ libraries }: { libraries: string }) => {
  // Only the library names matter to the Maps JS loader. Some call sites append a `types=`
  // hint (consumed later by the Places Autocomplete request via `placesFilterTypes`, not by
  // the loader). Keeping it in the URL made each caller's `src` unique, so `useScript` loaded
  // the whole Maps API multiple times ("You have included the Google Maps JavaScript API
  // multiple times…"). Strip everything after the library names so every caller resolves to a
  // single stable URL and Maps loads exactly once.
  const libraryNames = libraries.split('&')[0];
  const script = `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&libraries=${libraryNames}&region=IT`;
  const gmapsScript = useScript(script);
  useEffect(() => {
    if (gmapsScript === 'error') {
      // eslint-disable-next-line no-console
      console.error('Error loading GMAPS Script');
    }
  }, [gmapsScript]);
  return gmapsScript === 'ready';
};
